var map = {
	"./7Z.svg": "37e7",
	"./AAC.svg": "6b79",
	"./AEP.svg": "3ed5",
	"./AI.svg": "9a50",
	"./AVI.svg": "8980",
	"./AZW.svg": "aab4",
	"./BAT.svg": "6ab6",
	"./BIN.svg": "d84a",
	"./BMP.svg": "8ad8",
	"./CDR.svg": "b0bb",
	"./CSS-01.svg": "9b68",
	"./CSS-02.svg": "472a",
	"./CSV.svg": "0285",
	"./DAT.svg": "d581",
	"./DEFAULT.svg": "6af9",
	"./DJVU.svg": "6418",
	"./DLL.svg": "7cdf",
	"./DMG.svg": "13d5",
	"./DOC.svg": "d7a4",
	"./DOCX.svg": "d245",
	"./EML.svg": "0958",
	"./EPS.svg": "4e53",
	"./EPUB.svg": "2473",
	"./EXE.svg": "725c",
	"./FLA.svg": "c62e",
	"./FLAC.svg": "43d2",
	"./GIF.svg": "4f2a",
	"./HTML.svg": "aef4",
	"./ICO.svg": "75ed",
	"./INDD.svg": "0c57",
	"./INI.svg": "506a",
	"./ISO.svg": "ec46",
	"./JAR.svg": "8832",
	"./JPEG.svg": "2533",
	"./JPG.svg": "21b5",
	"./JS.svg": "60d9",
	"./KEY.svg": "1d69",
	"./MIDI.svg": "c979",
	"./MKV.svg": "1ecf",
	"./MOBI.svg": "5489",
	"./MOV.svg": "c3a5",
	"./MP3.svg": "78ff",
	"./MP4.svg": "e709",
	"./NFO.svg": "ba7f",
	"./NUMBERS.svg": "3528",
	"./OGG.svg": "543d",
	"./OTF.svg": "a638",
	"./PAGES.svg": "3fc2",
	"./PDF.svg": "4cdb",
	"./PHP.svg": "e229",
	"./PNG.svg": "f84f",
	"./PPT.svg": "6274",
	"./PPTX.svg": "b5ee",
	"./PSD.svg": "24a0b",
	"./RAR.svg": "ad30",
	"./RAW.svg": "2340",
	"./RTF.svg": "7ff5",
	"./SQL.svg": "74b3",
	"./SUB.svg": "8a6d",
	"./SVG.svg": "d12b",
	"./SWF.svg": "e8b1",
	"./SYS.svg": "9035",
	"./TTF.svg": "4b15",
	"./TXT.svg": "e764",
	"./URL.svg": "521b",
	"./WAV.svg": "09f4b",
	"./WMV.svg": "092b",
	"./XLS.svg": "6f86",
	"./XLSX.svg": "c76f",
	"./XMIND.svg": "e2c3",
	"./XML.svg": "f4a7",
	"./ZIP.svg": "9301"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ab94";